import { render, staticRenderFns } from "./PersonalAddressForm.vue?vue&type=template&id=71b1d9b2&"
import script from "./PersonalAddressForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalAddressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports